export default "__VITE_ASSET__CN10zTAl__"